// 推送相关的 API 信息
// 测试地址域名 https://push-dev.tradeup.com
// 线上域名 https://push.tradeup.com

import Vue from 'vue'

/**
 * 新增股价提醒
 * @param {string} data.market - 股票市场
 * @param {string} data.symbol - 股票代码
 * @param {number} data.category - 提醒大类
 * @param {number} data.alertType - 提醒子类
 * @param {object} data.condition - 提醒条件
 * @param {number} data.frequency - 提醒频率
 * @param {string} [data.message] - 自定义消息
 * @param {string} data.platform - 平台
 * @param {boolean} [data.enable] - 提醒开关
 * @returns {PromiseLike<HttpResponse>}
 */
export function createStockAlert(data) {
  return Vue.http.post('~push/v1/stock/alerts', data).then(d => d.body)
}

/**
 * 修改股价提醒。修改提醒参数和新增提醒参数基本一致
 * @typedef {object} st
 * @property {string} st.id 当前提醒的ID
 * @property {string} st.market - 股票市场
 * @property {string} st.symbol - 股票代码
 * @property {number} st.category - 提醒大类
 * @property {number} st.alertType - 提醒子类
 * @property {object} st.condition - 提醒条件
 * @property {number} st.frequency - 提醒频率
 * @property {string} [st.message] - 自定义消息
 * @property {string} st.platform - 平台
 * @property {boolean} [st.enable] - 提醒开关
 * @param {array<st>} data
 * @returns {PromiseLike<HttpResponse>}
 */
export function updateStockAlert(data) {
  return Vue.http.post('~push/v1/stock/alerts/update', data).then(d => d.body)
}

/**
 * 删除股价提醒
 * @param {string} id 当前提醒的ID
 * @returns {PromiseLike<HttpResponse>}
 */
export function deleteStockAlert(id) {
  return Vue.http.delete(`~push/v1/stock/alerts/${id}`).then(d => d.body)
}

/**
 * 批量删除股价提醒。删除所有symbol下的股价提醒
 * @typedef {object} st
 * @property {string} st.symbol - 股票代码
 * @param {array<st>} data - 批量数据列表
 * @returns {PromiseLike<HttpResponse>}
 */
export function deleteStockAlerts(data) {
  return Vue.http.delete('~push/v1/stock/alerts', data).then(d => d.body)
}

/**
 * 批量关闭股价提醒
 * @typeof {object} st
 * @property {string} st.market - 股票市场
 * @property {string} [st.symbol] - 股票代码
 * @property {number[]} [st.id] - 待关闭股价提醒 id 列表
 * @property {array<st>} [st.symbols] - 对应市场下的股票数据列表。这个值里数据不包含 market 字段。
 * @param {array<st>} data - 数据列表
 * @returns {PromiseLike<HttpResponse>}
 */
export function closeStockAlerts(data) {
  return Vue.http
    .post('~push/v1/stock/alerts/batch-disable', data)
    .then(d => d.body)
}

/**
 * 获取单支股票股价提醒
 * @param {string} params.market
 * @param {string} params.symbol
 * @param {number} params.page
 * @param {number} params.size
 * @returns {PromiseLike<HttpResponse>}
 */
export function getStockAlert(params) {
  return Vue.http
    .get('~push/v1/stock/alerts/{market}/{symbol}', { params })
    .then(d => d.body)
}

/**
 * 获取所有的股价提醒
 * @param {string} [params.market] - 标的市场类型
 * @param {string} [params.secType] - 标的类型
 * @param {number} [params.page] - 页码
 * @param {number} [params.size] - 每页大小
 * @param {number} [params.symbolSize] - 每个 symbol 展示的提醒个数
 */
export function getAllStockAlerts(params) {
  return Vue.http.get('~push/v1/stock/alerts', { params }).then(d => d.body)
}
